import styled from 'styled-components';
export const Row = styled.div.withConfig({
  displayName: "paginationcss__Row",
  componentId: "sc-r2lbm3-0"
})(["display:inline-flex;align-items:baseline;justify-items:space-between;width:100%;justify-content:space-between;padding-top:8rem;"]);